import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../config"; // adjust path as needed
import NavBar from "./NavBar";

function Investments() {
  const [investments, setInvestments] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState(null);

  const fetchInvestments = async (next = false) => {
    setLoading(true);
    try {
      const investRef = collection(db, "investments");
      let q = query(investRef, orderBy("createdAt", "desc"), limit(10));

      if (next && lastVisible) {
        q = query(
          investRef,
          orderBy("createdAt", "desc"),
          startAfter(lastVisible),
          limit(10)
        );
      }

      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setInvestments((prev) => (next ? [...prev, ...data] : data));
      setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    } catch (err) {
      console.error("Error fetching investments:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchInvestments();
  }, []);

  const handleStatusChange = async (id, newStatus, investment) => {
    setStatusUpdating(id);
    try {
      const investRef = doc(db, "investments", id);
      await updateDoc(investRef, { status: newStatus });

      // Update local state
      setInvestments((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        )
      );
    } catch (err) {
      console.error("Failed to update status:", err);
    }
    setStatusUpdating(null);
  };

  return (
    <div className="container mt-4">
      <nav className="main-header navbar navbar-expand navbar-white navbar-light mb-3">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>
      <NavBar />

      <h3 className="text-center mb-4">Investments</h3>

      {loading && <div className="text-center">Loading...</div>}

      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>Email</th>
              <th>Plan</th>
              <th>ROI (%)</th>
              <th>Duration</th>
              <th>Amount</th>
              <th>Created At</th>
              <th>Status</th>
              <th>Change Status</th>
            </tr>
          </thead>
          <tbody>
            {investments.map((investment) => (
              <tr key={investment.id}>
                <td>{investment.email}</td>
                <td>{investment.plan}</td>
                <td>{investment.roi}</td>
                <td>{investment.duration}</td>
                <td>${parseFloat(investment.amount).toFixed(2)}</td>
                <td>
                  {investment.createdAt?.toDate
                    ? investment.createdAt.toDate().toLocaleString()
                    : new Date(investment.createdAt).toLocaleString()}
                </td>
                <td>
                  <span
                    className={`badge bg-${
                      investment.status === "active"
                        ? "info"
                        : investment.status === "completed"
                        ? "success"
                        : "danger"
                    }`}
                  >
                    {investment.status}
                  </span>
                </td>
                <td>
                  <select
                    className="form-select"
                    disabled={statusUpdating === investment.id}
                    value={investment.status}
                    onChange={(e) =>
                      handleStatusChange(investment.id, e.target.value, investment)
                    }
                  >
                    <option value="active">Active</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {lastVisible && (
        <div className="text-center">
          <button
            className="btn btn-secondary"
            onClick={() => fetchInvestments(true)}
            disabled={loading}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
}

export default Investments;
